import React from "react";

const ProgramKerja = React.lazy(() => import('./ProgramKerja'));
const AddProgramKerja = React.lazy(() => import('./Pengisian/AddProgramKerja'));
const EditProgramKerja = React.lazy(() => import('./Pengisian/EditProgramKerja'));

export const programKerjaConfigs = [
    {
        path: '/program-kerja',
        element: <ProgramKerja />,
        roleAccess: ['PENGISIAN_PROGRAM_KERJA', 'MONITORING_PROGRAM_KERJA_ESELON_ALL', 'MONITORING_PROGRAM_KERJA_ESELON_1'],
    },
    {
        path: '/program-kerja/eselon/:id',
        element: <ProgramKerja />,
        roleAccess: ['PENGISIAN_PROGRAM_KERJA', 'MONITORING_PROGRAM_KERJA_ESELON_ALL', 'MONITORING_PROGRAM_KERJA_ESELON_1'],
    },
    {
        path: '/program-kerja/tambah',
        element: <AddProgramKerja />,
        roleAccess: ['PENGISIAN_PROGRAM_KERJA'],
    },
    {
        path: '/program-kerja/edit',
        element: <EditProgramKerja />,
        roleAccess: ['PENGISIAN_PROGRAM_KERJA'],
    },
];